import { v4 as uuidv4 } from 'uuid';
uuidv4();

let uuid = sessionStorage.getItem('pubnub_uuid');

if(!uuid){
	console.warn('No uuid, generating one.');
	uuid = uuidv4();
	sessionStorage.setItem('pubnub_uuid', uuid);
}

export default uuid
